import React from 'react';

import Loader from "../common/Loader";
import * as cargoActions from "../../actions/cargo";
import {connect} from "react-redux";
import CargoTable from "./CargoTable";
import CargoTabs from "./CargoTabs";
import {Button} from "react-materialize";
import * as creationActions from "../../actions/creation";
import CargoSummary from "./CargoSummary";

class CargoTableWrapper extends React.Component {

    componentDidMount() {
        this.props.dispatch(cargoActions.fetchCargoes(this.props.fog.id, true));
    }

    render() {
        if (this.props.loading || this.props.cargoes === undefined) {
            return (<div><Loader /></div>)
        }

        return (
            <div className="cargo-tab">
                <CargoSummary cargoes={this.props.cargoes} loading={this.props.loading} />
                <Button floating onClick={() => this.props.openDrawer(CargoTabs, {item: null, fog: this.props.fog}, creationActions.destroyingnewlyCreatedCargo())} icon="add" className="add-button" />
                <CargoTable {...this.props} data={this.props.cargoes} />
                <Button floating onClick={() => this.props.openDrawer(CargoTabs, {item: null, fog: this.props.fog}, creationActions.destroyingnewlyCreatedCargo())} icon="add" className="add-button" />
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        cargoes: state.cargo.cargoes,
        loading: state.cargo.loading,
        deleting: state.cargo.deleting
    });
})(CargoTableWrapper);


// WEBPACK FOOTER //
// ./src/components/cargo/CargoTableWrapper.js